import React from "react";
import TextToHTML from "presentational/common/TextToHTML";
import CommonHeaderTextForTranslatedLegalTerms from "presentational/termsAndPrivacy/CommonHeaderTextForTranslatedLegalTerms";
import PropTypes from "prop-types";

PrivacyText.propTypes = {
  language: PropTypes.oneOf(["ko", "en"]).isRequired
};

const title = { ko: "개인정보 처리방침", en: "Privacy Policy" };

const text = {
  ko: `
  어메이브 주식회사(이하 ‘회사')는 정보주체의 자유와 권리 보호를 위해 「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. 이에 「개인정보 보호법」 제30조에 따라 정보주체에게 개인정보 처리에 관한 절차 및 기준을 안내하고, 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보처리방침을 수립·공개합니다.

개인정보의 처리 목적
  회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 「개인정보 보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
    1) 회원 가입 및 관리
      - 회원 가입 의사 확인, 서비스 내 이용자 식별 및 인증, 회원 관리, 부정이용 방지, 각종 고지 및 통지, 고충처리 목적으로 개인정보를 처리합니다.
    2) 서비스 제공
      - 서비스 제공, 계약서·청구서 발송, 요금 결제/정산, 콘텐츠 및 회원 맞춤 서비스 제공, 본인인증, 채권추심의 목적으로 개인정보를 처리합니다.

개인정보의 처리 및 보유기간
  1. 회사는 법령에 따른 개인정보 보유 및 이용 기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유 및 이용 기간 내에서 개인정보를 처리·보유합니다.
  2. 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.
    1) 회원 가입 및 관리 : 회원 가입 계약 해지 시까지
      다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지
      - 관계 법령 위반에 따른 수사·조사 등이 진행 중인 경우에는 해당 수사·조사 종료 시까지
      - 서비스 이용에 따른 채권·채무관계 잔존 시에는 해당 채권·채무관계 정산 시까지
    2) 서비스 제공 : 회원 가입 계약 해지 시까지
      다만, 다음의 사유에 해당하는 경우에는 해당 기간 종료 시까지
      - 계약 또는 청약철회 등에 관한 기록 (전자상거래법 5년)
      - 대금 결제 및 재화 등의 공급에 관한 기록 (전자상거래법 5년)
      - 소비자의 불만 또는 분쟁처리에 관한 기록 (전자상거래법 3년)
      - 표시/광고에 관한 기록 (전자상거래법 6개월)
      - 전자금융 거래에 관한 기록 (전자금융거래법 5년)

처리하는 개인정보 항목
  회사는 다음의 개인정보 항목을 처리하고 있습니다.
    1) 회원 가입 및 관리
      - 이메일 주소, 비밀번호, 사용자 이름
    2) 서비스 제공
      - 이메일 주소, 사용자 이름, 생년월일, 성별, 거주 위치

만 14세 미만 아동의 개인정보 처리에 관한 사항
  회사는 만 14세 미만 아동의 개인정보보호를 위하여 만 14세 이상의 이용자에 한하여 회원가입을 허용합니다.

개인정보의 제3자 제공
  회사는 정보주체의 개인정보를 개인정보의 처리 목적에서 명시한 범위 내에서 만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제17조 및 제18조에 해 당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 정보주체의 개인정보를 제3자에게 제공하지 않습니다.

개인정보 처리의 위탁
  1. 회사는 원활한 개인정보 업무처리를 위하여 국외에 개인정보 처리업무를 위탁하고 있으며, 이용자로부터 취득 또는 생성한 개인정보를 AWS (Amazon Web Services Inc.)가 보유하고 있는 데이터베이스에 저장합니다. AWS는 해당 서버의 물리적인 관리만을 행하고, 이용자의 개인정보에 접근할 수 없습니다.
    - 위탁받는 자 (수탁자) : Amazon Web Services, Inc
    - 수탁자의 위치 : 미국(AWS 버지니아 북부 리전)
    - 위탁 일시 및 방법: 서비스 이용 시점에 네트워크를 이용한 원격지 전송
    - 위탁하는 개인정보 항목 : 회원정보, 결제 정보
    - 위탁 업무 내용 : 데이터 보관
    - 개인정보의 보유 및 이용 기간 : 회원 탈퇴 완료 시까지 혹은 위탁계약 종료 시까지
  2. 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체 없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.

개인정보의 파기 절차 및 방법
  1. 회사는 개인정보 보유기간의 경과, 처리 목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체 없이 해당 개인정보를 파기합니다.
  2. 정보주체로부터 동의 받은 개인정보 보유기간이 경과하거나 처리 목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터 베이스(DB)로 옮기거나 보관 장소를 달리하여 보존합니다.
  3. 개인정보 파기의 절차 및 방법은 다음과 같습니다.
    1) 파기절차 : 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인 정보 보호 책임자의 승인을 받아 개인정보를 파기합니다.
    2) 파기방법 : 회사는 전자적 파일 형태로 기록·저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록·저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.

정보주체와 법정대리인의 권리·의무 및 행사방법
  1. 회원은 언제든지 본인의 개인정보를 확인, 조회하거나 수정할 수 있으며 가입해지 또는 개인정보의 삭제를 요청할 수도 있습니다. 단, 서비스 제공을 위해 반드시 필요한 개인정보를 삭제하는 경우 관련 서비스를 제공받지 못할 수 있습니다.
  2. 사용자 이름, 비밀번호의 수정을 위해서는 '사용자 이름 변경'과 '비밀번호 변경'을, 이용계약 해지를 위해서는 '계정 삭제'를 클릭하여 정정 또는 탈퇴가 가능합니다.
  3. 회원은 개인정보중 이메일 주소, 생년월일, 성별, 거주 위치에 한하여 회원 가입 완료 후 이를 수정할 수 없으므로 정확하게 입력하여야 합니다. 회원이 입력한 부정확한 정보로 인해 발생하는 손해 및 사고의 책임은 회사가 부담하지 않습니다. 부득이한 사유로 인하여 변경하고자 하는 경우에는 이용계약을 해지하고 재가입하여야 합니다.
  4. 회원은 본인의 개인정보를 스스로 보호하고 타인의 정보를 침해하지 않을 의무를 가지고 있습니다. 비밀번호를 포함한 본인의 개인정보가 유출되지 않도록 주의하시고 타인의 개인정보와 게시물을 훼손하지 않도록 유의하여야 합니다.
  5. 개인정보의 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.

개인정보의 안전성 확보 조치
  1. 회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.
    1) 관리적 조치 : 개인정보 접근 가능 인원 제한, 내부관리 계획 수립/시행, 전담조직 운영
    2) 기술적 조치 : 개인정보 전송 시 암호화된 통신구간 이용, 개인정보 접근 권한 관리, 비밀번호 암호화
    3) 물리적 조치 : 데이터베이스 접근 기기/공간 통제
  2. 회사는 회원 개인의 실수나 기본적인 인터넷의 위험성 때문에 일어나는 일들에 대해 책임을 지지 않습니다. 회원 개개인이 본인의 개인정보를 보호하기 위해서 비밀번호를 적절하게 관리하고 여기에 대한 책임을 져야 합니다.

개인정보 자동 수집 장치의 설치·운영 및 거부에 관한 사항
  1. 회사는 회원에게 개별적인 맞춤 서비스를 제공하기 위해 이용 정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다.
  2. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 회원의 컴퓨터/모바일 브라우저에게 보내는 소량의 정보이며 회원의 기기 내 하드디스크에 저장됩니다.
  3. 쿠키는 회원이 아닌 회원의 기기만을 식별하며, 로그인 유지, 아이디 저장, 이용 형태 분석 등 이용자에게 최적화된 서비스를 제공하기 위하여 사용됩니다.
  4. 회사는 구글 애널리틱스(Google Analytics)를 이용하여 로그 분석을 합니다. 회원을 식별할 수 없으며 전체적인 로그 분석에만 이용합니다.
  5. 회원은 쿠키에 대한 선택권이 있습니다. 웹 브라우저 종류에 따라 다소 상이할 수 있지만, 대부분 웹브라우저의 환경 설정을 통해 쿠키 허용 여부를 결정하거나 기존의 쿠키 일체를 삭제할 수 있습니다. 다만 쿠키의 저장을 거부할 경우, 로그인이 필요한 일부 서비스의 이용에 제한이 생길 수 있습니다.

개인정보 보호 책임자
  1. 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보의 열람 및 개인정보 처리와 관련한 정보주체의 불만 처리 및 피해 구제 등을 위하여 아래와 같이 개인정보 보호 책임자를 지정하고 있습니다.
    - 개인정보 보호 책임자
      - 성명 : 김재하
      - 소속 : 고객센터
      - 이메일 : help@maunent.com
  2. 정보주체는 회사의 서비스를 이용하시면서 발생한 모든 개인정보보호 관련 문의, 불만 처리, 피해 구제 등에 관한 사항을 개인정보 보호 책임자 및 담당 부서로 문의할 수 있습니다. 회사는 정보주체의 문의에 대해 지체 없이 답변 및 처리해 드릴 것입니다.

권익 침해 구제방법
  1. 정보주체는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁 해결이나 상담 등을 신청할 수 있습니다. 이 밖에 기타 개인정보침해의 신고, 상담에 대하여는 아래의 기관에 문의하시기 바랍니다.
    1) 개인정보분쟁조정위원회 : (국번 없이) 1833-6972 (www.kopico.go.kr)
    2) 개인정보침해신고센터 : (국번 없이) 118 (privacy.kisa.or.kr)
    3) 대검찰청 : (국번 없이) 1301 (www.spo.go.kr)
    4) 경찰청 : (국번 없이) 182 (ecrm.cyber.go.kr)

개인정보 처리방침의 변경
  이 개인정보처리방침은 2023년 7월 27일부터 적용됩니다.
`,
  en: `
  AMAIVE Corp.(hereinafter referred to as the "Company") complies with the Personal Information Protection Act and related laws and regulations to protect the freedom and rights of information subjects. The company processes personal information legally and manages it securely. In accordance with Article 30 of the Personal Information Protection Act, the company has established and disclosed this Privacy Policy to guide information subjects in the procedures and standards of personal information processing. This policy aims to ensure that any grievances related to personal information processing can be handled promptly and smoothly.

Purpose of Processing Personal Information
  The company processes personal information for the following purposes. The personal information being processed will not be used for any purpose other than the following purposes, and if the purpose of use changes, we plan to take necessary measures such as obtaining separate consent in accordance with Article 18 of the "Personal Information Protection Act".
    1) Member registration and management
      - We process personal information for the purpose of confirming membership intentions, identifying and authenticating users within the service, member management, preventing unauthorized use, various notifications and notices, and handling grievances.
    2) Service provision
      - We process personal information for the purpose of providing services, sending contracts and invoices, billing/payment settlement, providing content and tailored services for members, identity verification, and debt collection.

Processing and Retention Period of Personal Information
  1. The company processes and retains personal information within the personal information retention and usage period specified by the law or within the retention and usage period agreed upon when collecting personal information from the information subject.
  2. The processing and retention period for each personal information is as follows:
  1) Member registration and management: Until the termination of the membership agreement
    However, if any of the following reasons apply, until the end of the respective reason:
      - Until the end of the investigation in case of ongoing investigations due to violations of related laws
      - Until the settlement of outstanding claims and debts related to service usage
  2) Service provision: Until the termination of the membership agreement
    However, if any of the following reasons apply, until the end of the respective period:
      - Records related to contracts or subscription withdrawals (Electronic Commerce Act: 5 years)
      - Records related to payment and supply of goods, etc. (Electronic Commerce Act: 5 years)
      - Records related to consumer complaints or dispute resolution (Electronic Commerce Act: 3 years)
      - Records related to display/advertising (Electronic Commerce Act: 6 months)
      - Records related to electronic financial transactions (Electronic Financial Transactions Act: 5 years)

Personal Information Items Being Processed
  The company processes the following personal information items:
    1) Member registration and management
      - Email address, password, username
    2) Service provision
      - Email address, username, date of birth, gender, place of residence

Matters Concerning the Processing of Personal Information of Children Under 14 Years of Age
  To protect the personal information of children under the age of 14, the company only permits membership registration for users aged 14 years or older.

Providing Personal Information to Third Parties
  The company processes the personal information of the information subject only within the scope specified in the purpose of processing personal information and does not provide the personal information of the information subject to third parties unless there is the consent of the information subject or special provisions of the law, as specified in Articles 17 and 18 of the "Personal Information Protection Act". Personal information is not provided to third parties in any other case.

Delegation of Personal Information Processing
  1. The company delegates personal information processing tasks overseas for smooth personal information work processing and stores personal information acquired or generated from users in a database owned by AWS (Amazon Web Services Inc.). AWS only physically manages the server and cannot access users' personal information.
    - Delegation receiver (Trustee): Amazon Web Services, Inc.
    - Location of the trustee: United States (AWS Northern Virginia Region)
    - Delegation date and method: Remote transmission via network at the time of service usage
    - Personal information items delegated: Member information, payment information
    - Delegated work details: Data storage
    - Retention and usage period of personal information: Until the completion of membership withdrawal or termination of the delegation contract
  2. If the content of the entrusted work or the trustee changes, we will promptly disclose it through this privacy policy.

Destruction Procedure and Method of Personal Information
  1. The company destroys the personal information without delay when the personal information becomes unnecessary due to the expiry of the retention period or the achievement of the processing purpose.
  2. If the personal information should still be retained according to other laws despite having the consented retention period expired or achieving the processing purpose, the company will either move the personal information to a separate database or change the storage location.
  3. The procedure and method for destroying personal information are as follows:
    1) Destruction procedure: The company selects personal information for which the destruction reasons have occurred, and with the approval from the company's personal information protection manager, the personal information is destroyed.
    2) Destruction method: The company destroys electronically recorded and stored personal information in a manner that prevents records from being restored, while personal information recorded and stored on paper documents is destroyed by shredding or incineration.

Rights, Duties, and Exercise Methods of the Information Subject and Legal Representative
  1. Members can check, inquire, or modify their personal information at any time and can also request membership cancellation or deletion of personal information. However, if you delete personal information that is essential for providing services, you may not be able to receive related services.
  2. To modify the username and password, click 'Change Username' and 'Change Password'; to terminate the service agreement, click 'Delete Account' to make corrections or withdraw.
  3. Members can only modify their email address, date of birth, gender, and residence after completing registration, so they must enter the information accurately. The company is not responsible for damages and accidents caused by the member's inaccurate information. If you need to change the information due to unavoidable reasons, you must cancel the usage agreement and re-apply.
  4. Members have an obligation to protect their own personal information and not infringe on others' information. Please take care to prevent the leakage of your personal information, including passwords, and refrain from damaging others' personal information and postings.
  5. Personal information deletion requests cannot be made if the information is specified as a collection target under other legislation.

Ensuring the Safety of Personal Information
  1. The company takes the following measures to ensure the safety of personal information:
    1) Administrative measures: Limiting the number of people who can access personal information, establishing and implementing internal management plans, operating dedicated organizations
    2) Technical measures: Using encrypted communication channels when transmitting personal information, managing access rights to personal information, encrypting passwords
    3) Physical measures: Controlling access to devices and spaces for database access
  2. The company is not responsible for any incidents caused by member's mistakes or basic internet dangers. Individual members must properly manage their passwords and assume responsibility for protecting their personal information.

Matters Concerning the Installation, Operation, and Refusal of Automatic Personal Information Collection Devices
  1. The company uses 'cookies' to store and retrieve usage information to provide customized services for members.
  2. A cookie is a small piece of information sent by the server operating a website to the member's computer or mobile browser, and it is stored on the member's device hard drive.
  3. Cookies identify the member's device, not the member themselves, and are used to provide optimized services such as maintaining login status, saving user IDs, and analyzing usage patterns.
  4. The company uses Google Analytics for log analysis. This tool does not identify members and is only used for overall log analysis.
  5. Members can choose whether to accept cookies. The options may vary slightly depending on the browser type, but most web browsers allow users to determine cookie acceptance through their settings or delete all existing cookies. However, if you refuse to store cookies, some restrictions may apply when using services that require login.

Personal Information Protection Manager
  1. The company is responsible for overseeing personal information processing tasks and has designated a personal information protection manager to handle tasks such as accessing personal information and addressing complaints and damage remediation related to personal information processing.
    - Personal Information Protection Manager
      - Name: Kim Jae Ha
      - Affiliation: Customer Center
      - Email: help@maunent.com
  2. Information subjects can direct any inquiries, complaints, or damage relief related to personal information protection that arise while using the company's services to the personal information protection manager and the responsible department. The company will respond and handle the inquiry without delay.

Remedy for Infringement of Rights
  1. Information subjects can apply for dispute resolution or consultation at the Personal Information Dispute Mediation Committee and the Korea Internet & Security Agency's Personal Information Infringement Report Center to receive remedies for personal information infringement. For reporting and consultation on other personal information infringements, please contact the following institutions:
    1) Personal Information Dispute Mediation Committee: (without area code) 1833-6972 (www.kopico.go.kr)
    2) Personal Information Infringement Report Center: (without area code) 118 (privacy.kisa.or.kr)
    3) Supreme Prosecutors' Office: (without area code) 1301 (www.spo.go.kr)
    4) National Police Agency: (without area code) 182 (ecrm.cyber.go.kr)

Changes in the Privacy Policy
  This Privacy policy will be applied from July 27th, 2023.
`
};

function PrivacyText(props) {
  const { language } = props;

  return (
    <div>
      {language === "en" && (
        <CommonHeaderTextForTranslatedLegalTerms language={language} />
      )}
      <TextToHTML title={title[language]} text={text[language]} />
    </div>
  );
}

export default PrivacyText;
